// `/login/force` (U9) — legacy route that logs the current session out and
// shows the login form (used by kiosks / shared terminals).

import { useEffect } from 'react';

import { logout } from '../../api/client';
import { LoadingBlock } from '../../components/StateBlock';
import { getRuntimeConfig } from '../../runtime';
import { resetLocationState } from '../../session/location';

export function ForceLoginPage() {
  useEffect(() => {
    resetLocationState();
    logout()
      .catch(() => undefined)
      .finally(() => {
        const base = getRuntimeConfig().basePath.replace(/\/$/, '');
        window.location.replace(`${base}/`);
      });
  }, []);
  return <LoadingBlock />;
}
